import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  return <section className="py-20 bg-purple-900 text-white relative overflow-hidden" data-id="element-237">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-238">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-239"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-240">
        <div className="max-w-3xl mx-auto text-center" data-id="element-241">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-12 font-serif text-pink-200" data-id="element-242">
            Lo Que Cambia En Tu Vida
          </motion.h2>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="space-y-6 text-xl md:text-2xl font-medium mb-16" data-id="element-243">
            <p className="transform transition-transform hover:scale-105 duration-300" data-id="element-244">
              Duermes mejor.
            </p>
            <p className="transform transition-transform hover:scale-105 duration-300" data-id="element-245">
              Dejas de revisar tu cuenta con miedo.
            </p>
            <p className="transform transition-transform hover:scale-105 duration-300" data-id="element-246">
              Discutes menos por dinero.
            </p>
            <p className="transform transition-transform hover:scale-105 duration-300" data-id="element-247">
              Te sientes capaz y organizada.
            </p>
            <p className="transform transition-transform hover:scale-105 duration-300 text-pink-300" data-id="element-248">
              Empiezas a planear en lugar de sobrevivir.
            </p>
            <p className="transform transition-transform hover:scale-105 duration-300 text-amber-300 font-bold text-3xl pt-4" data-id="element-249">
              Recuperas tu poder.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20" data-id="element-250">
            <p className="text-2xl mb-2" data-id="element-251">Porque cuando controlas tu dinero…</p>
            <p className="text-3xl md:text-4xl font-bold text-amber-400" data-id="element-252">
              Recuperas tu tranquilidad.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}